"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useFocusedElementChange", {
    enumerable: true,
    get: function() {
        return useFocusedElementChange;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _useTabster = require("./useTabster");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
function useFocusedElementChange(callback) {
    const tabster = (0, _useTabster.useTabster)();
    _react.useEffect(()=>{
        if (tabster) {
            tabster.focusedElement.subscribe(callback);
            return ()=>tabster.focusedElement.unsubscribe(callback);
        }
    }, [
        tabster,
        callback
    ]);
}
